import { composeIO } from 'react-compose-io'
import { boxValorIO } from './BoxValor.IO'
import BoxValorView from './BoxValor.View'

export const BoxValor = composeIO(BoxValorView, boxValorIO)
